export const ADD_ITEM_TO_CART_AND_REDIRECT_ACTION =
  "ADD_ITEM_TO_CART_AND_REDIRECT"
